import React from 'react'
import { useStore } from '../../../Stores/store';
import { Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { Category } from '../../../Models/Category';

export default observer(function CategoryForm(){
    const { categoryStore } = useStore();
    const { updateCategory, selectedCategory, createCategory } = categoryStore;

    const formVals : Category = selectedCategory ?? {
        id: 0,
        name: "",
      }

    const handleSubmit = (values : any) => {
        if(values.id === undefined || values.id === 0){
            createCategory(values as Category)
        }
        else {
            updateCategory(values as Category)
        }
    }

    return (
        <div className="p-4">
            <Formik
                initialValues={formVals}
                onSubmit={(values) => handleSubmit(values)}
                enableReinitialize
                >
                {({handleSubmit, handleChange, values}) => (
                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    <div className="flex flex-col gap-1">
                        <label htmlFor="name" className="text-sm font-medium text-gray-700">Name</label>
                        <input type="text" name="name" id="name" value={values.name} onChange={handleChange} className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500" />
                    </div>
                    <input type="hidden" id="id" name="id" value={values.id} />
                    <button type="submit" className="w-full mt-2 bg-gray-800 text-white py-2 px-4 rounded-md hover:bg-gray-700 transition-colors text-sm font-medium cursor-pointer">Save Category</button>
                </form>
                )}
            </Formik>
        </div>
    )
});